(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    let stopWaiting = () => {};

    const revealLinkedReviews = () => {
      stopWaiting();
      if (window.location.hash !== '#yotpo-reviews-main-widget') return;

      let observer;
      let timeout;
      const stop = () => {
        observer?.disconnect();
        window.clearTimeout(timeout);
        window.removeEventListener('wheel', stop);
        window.removeEventListener('touchstart', stop);
      };
      stopWaiting = stop;

      const reveal = () => {
        const reviews = document.getElementById('yotpo-reviews-main-widget');
        if (!reviews || reviews.getBoundingClientRect().height < 50) return false;
        stop();
        window.requestAnimationFrame(() => reviews.scrollIntoView({ block: 'start', behavior: 'instant' }));
        return true;
      };

      if (reveal()) return;
      observer = new MutationObserver(reveal);
      observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-yotpo-element-loaded'] });
      timeout = window.setTimeout(stop, 15000);
      window.addEventListener('wheel', stop, { passive: true, once: true });
      window.addEventListener('touchstart', stop, { passive: true, once: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', revealLinkedReviews, { once: true });
    } else {
      revealLinkedReviews();
    }
    window.addEventListener('hashchange', revealLinkedReviews);
  })();

  } catch(e) { console.error(e); }
})();
})();
